<template>
  <div style="margin: 20px 0; font-family: -apple-system-font,PingFang SC,Helvetica Neue,Helvetica,STHeiTi,sans-serif;">
    <el-row type="flex" justify="center">
      <el-col :span="18">
        <el-image :src="imgList[order].img1" fit="fill"></el-image>
      </el-col>
    </el-row>

    <el-row type="flex" justify="center">
      <el-col :span="18">
        <el-image :src="imgList[order].img2" fit="fill"></el-image>
      </el-col>
    </el-row>

    <el-row type="flex" justify="center">
      <el-col :span="18">
        <p style="text-align: center;font-size: 0.32rem;">实现方式</p>
      </el-col>
    </el-row>

    <el-row type="flex" justify="center" style="margin: 0 10px; ">
      <el-col :span="18">
        <p style="font-size: 28px">
          客户仅需提供项目运行基本信息，我们即可根据客户需求进行灵活全面的后续服务：方案设计、报价付款、硬件采购、项目实施等环节均在E平台一站式完成。调试完成后，微平台产品将通过算法模型的优化，为企业持续稳定地增效</p>
      </el-col>
    </el-row>

    <el-row type="flex" justify="center">
      <el-col :span="18">
        <p style="text-align: center;font-size: 0.32rem;">实现流程</p>
      </el-col>
    </el-row>

    <el-row type="flex" justify="center">

      <el-col :span="4">
        <a href="http://design.eiiplat.com/" target="_blank">
          <el-image :src="processImg[0]" fit="fill">
          </el-image>
        </a>
      </el-col>

      <el-col :span="1">
        <el-image :src="processImg[4]" fit="fill">
        </el-image>
      </el-col>

      <el-col :span="4">
        <a href="http://scmfin.eiiplat.com/" target="_blank">
          <el-image :src="processImg[1]" fit="fill">
          </el-image>
        </a>
      </el-col>

      <el-col :span="1">
        <el-image :src="processImg[4]" fit="fill">
        </el-image>
      </el-col>

      <el-col :span="4">
        <a href="http://gy.eiiplat.com/" target="_blank">
          <el-image :src="processImg[2]" fit="fill">
          </el-image>
        </a>
      </el-col>

      <el-col :span="1">
        <el-image :src="processImg[4]" fit="fill">
        </el-image>
      </el-col>

      <el-col :span="4">
        <a href="http://sg.eiiplat.com/" target="_blank">
          <el-image :src="processImg[3]" fit="fill">
          </el-image>
        </a>
      </el-col>
    </el-row>

    <el-row type="flex" justify="center">
      <el-col :span="18">
        <p style="font-size: 0.32rem;">各产品使用手册</p>
      </el-col>
    </el-row>

    <el-row type="flex" justify="center" v-for="(item, index) in fileList" :key="index">
      <el-col :span="18">
        <a style="font-size: 28px" :href="item.url" target="_blank">{{ item.name }}</a>
      </el-col>
    </el-row>
  </div>
</template>

<script>

export default {
  name: 'ProductSolution',
  created () {
    this.order = this.$route.query.id
    this.fileList.push(this.otherList[this.order])
  },
  data () {
    return {
      order: 0,
      img: '/api/jz/file/download/pt-eiiplat-lcdt/%E6%B5%81%E7%A8%8B.png',
      imgList: [
        { img1: '/api/jz/file/download/pt-eiiplat-lcdt/%E6%99%BA%E8%83%BD%E9%A2%84%E5%A4%84%E7%90%86-01.png', img2: '/api/jz/file/download/pt-eiiplat-lcdt/%E6%99%BA%E8%83%BD%E9%A2%84%E5%A4%84%E7%90%86-02.png' },
        { img1: '/api/jz/file/download/pt-eiiplat-lcdt/%E6%99%BA%E8%83%BD%E5%8E%8C%E6%B0%A7-01.png', img2: '/api/jz/file/download/pt-eiiplat-lcdt/%E6%99%BA%E8%83%BD%E5%8E%8C%E6%B0%A7-02.png' },
        { img1: '/api/jz/file/download/pt-eiiplat-lcdt/%E6%99%BA%E8%83%BD%E7%94%9F%E7%89%A9%E8%84%B1%E7%A1%AB-01.png', img2: '/api/jz/file/download/pt-eiiplat-lcdt/%E6%99%BA%E8%83%BD%E7%94%9F%E7%89%A9%E8%84%B1%E7%A1%AB-02.png' },
        { img1: '/api/jz/file/download/pt-eiiplat-lcdt/%E6%99%BA%E8%83%BD%E9%99%A4%E8%87%AD-01.png', img2: '/api/jz/file/download/pt-eiiplat-lcdt/%E6%99%BA%E8%83%BD%E9%99%A4%E8%87%AD-02.png' },
      ],
      fileList: [
        { name: '智能产品微平台上线（设计-施工-采购）流程联通操作说明', url: '/api/jz/file/download/pt-eiiplat-lcdt/01%E6%99%BA%E8%83%BD%E4%BA%A7%E5%93%81%E5%BE%AE%E5%B9%B3%E5%8F%B0%E4%B8%8A%E7%BA%BF%EF%BC%88%E8%AE%BE%E8%AE%A1-%E6%96%BD%E5%B7%A5-%E9%87%87%E8%B4%AD%EF%BC%89%E6%B5%81%E7%A8%8B%E8%81%94%E9%80%9A%E6%93%8D%E4%BD%9C%E8%AF%B4%E6%98%8E.pdf' },
        { name: '智能设计系统操作手册', url: '/api/jz/file/download/pt-eiiplat-lcdt/02%E6%99%BA%E8%83%BD%E8%AE%BE%E8%AE%A1%E7%B3%BB%E7%BB%9F%E6%93%8D%E4%BD%9C%E6%89%8B%E5%86%8C.pdf' },
        { name: '智能供应系统_采购商操手册', url: '/api/jz/file/download/pt-eiiplat-lcdt/03%E6%99%BA%E8%83%BD%E4%BE%9B%E5%BA%94%E7%B3%BB%E7%BB%9F_%E9%87%87%E8%B4%AD%E5%95%86%E6%93%8D%E6%89%8B%E5%86%8C.pdf' },
        { name: '施工管理系统操作手册', url: '/api/jz/file/download/pt-eiiplat-lcdt/04%E6%96%BD%E5%B7%A5%E7%AE%A1%E7%90%86%E7%B3%BB%E7%BB%9F%E6%93%8D%E4%BD%9C%E6%89%8B%E5%86%8C.pdf' }
      ],
      otherList: [
        { name: '智能预处理微平台产品资料', url: '/api/jz/file/download/pt-eiiplat-lcdt/%E6%99%BA%E8%83%BD%E9%A2%84%E5%A4%84%E7%90%86%E5%BE%AE%E5%B9%B3%E5%8F%B0%E4%BA%A7%E5%93%81%E8%B5%84%E6%96%99.pdf' },
        { name: '智能厌氧微平台产品资料', url: '/api/jz/file/download/pt-eiiplat-lcdt/%E6%99%BA%E8%83%BD%E5%8E%8C%E6%B0%A7%E4%BA%A7%E5%93%81%E8%B5%84%E6%96%99.pdf' },
        { name: '智能生物脱硫微平台产品资料', url: '/api/jz/file/download/pt-eiiplat-lcdt/%E6%99%BA%E8%83%BD%E7%94%9F%E7%89%A9%E8%84%B1%E7%A1%AB%E5%BE%AE%E4%BA%A7%E5%93%81%E8%B5%84%E6%96%99.pdf' },
        { name: '智能除臭微平台产品资料', url: '/api/jz/file/download/pt-eiiplat-lcdt/%E6%99%BA%E8%83%BD%E9%99%A4%E8%87%AD%E4%BA%A7%E5%93%81%E6%89%8B%E5%86%8C.pdf' }
      ],
      processImg: [
        '/api/jz/file/download/pt-eiiplat-lcdt/%E6%B5%81%E7%A8%8B1.png',
        '/api/jz/file/download/pt-eiiplat-lcdt/%E6%B5%81%E7%A8%8B2.png',
        '/api/jz/file/download/pt-eiiplat-lcdt/%E6%B5%81%E7%A8%8B3.png',
        '/api/jz/file/download/pt-eiiplat-lcdt/%E6%B5%81%E7%A8%8B4.png',
        '/api/jz/file/download/pt-eiiplat-lcdt/%E6%B5%81%E7%A8%8B-%E7%AE%AD%E5%A4%B4.png'
      ]
    }
  },
}
</script>



// WEBPACK FOOTER //
// src/components/ProductSolution.vue